export default "__VITE_ASSET__RhrwjgAd__"